export default "__VITE_ASSET__4n_wtgK___"